export default (state = null, action = {}) =>
  (action.type === 'TOKEN' && action.payload) || state



// WEBPACK FOOTER //
// ./src/reducers/jwToken.js